/*
 * ComingSoonPage — shared shell for services still in the pipeline.
 *
 * Renders a beautiful "under construction / coming in phase X" screen so the
 * navigation is complete from day one and users understand where each vertical
 * lives. Each service passes its icon, title, phase, and roadmap bullets.
 */
import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ArrowRight } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import LogisticsLayout from './LogisticsLayout';

const ComingSoonPage = ({ Icon, title, tag, phase, bullets = [], testid }) => {
  const navigate = useNavigate();
  return (
    <LogisticsLayout>
      <motion.section
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl"
        data-testid={testid}
      >
        <span className="ls-overline flex items-center gap-2 mb-4" style={{ color: 'var(--ls-primary)' }}>
          <Clock size={12} weight="fill" /> {phase}
        </span>
        <div className="flex items-start gap-6 mb-6">
          <div className="ls-elevated p-4">
            <Icon size={56} weight="duotone" style={{ color: 'var(--ls-primary)' }} />
          </div>
          <div>
            <p className="ls-overline mb-2">{tag}</p>
            <h1 className="ls-heading text-3xl sm:text-4xl font-bold tracking-tight leading-tight">{title}</h1>
          </div>
        </div>

        <p className="text-base mb-6" style={{ color: 'var(--ls-muted)' }}>
          The scaffolding is live and the routing is wired. The feature itself
          lands in the phase above so we keep the wallet, cards, and disruption
          engine correct before piling on service verticals.
        </p>

        <div className="ls-surface p-5 mb-6" data-testid={`${testid}-roadmap`}>
          <p className="ls-overline mb-3">What ships here</p>
          <ul className="space-y-2">
            {bullets.map((b, i) => (
              <li key={i} className="text-sm flex gap-2" style={{ color: 'var(--ls-secondary)' }}>
                <span style={{ color: 'var(--ls-primary)' }}>▸</span> {b}
              </li>
            ))}
          </ul>
        </div>

        <button className="ls-btn-primary" onClick={() => navigate('/hub/logistics')} data-testid={`${testid}-back`}>
          Back to home <ArrowRight size={14} weight="bold" />
        </button>
      </motion.section>
    </LogisticsLayout>
  );
};

export default ComingSoonPage;
